export const DFP_BANNER = {
  TOP_SIDE_1140x250: {
    path: '/150277392/FMPedia_IL/Super_LeaderBoard',
    sizes: [
      [1140, 90],
      [1100, 100],
      [980, 120],
      [980, 90],
      [970, 250],
      [970, 120],
      [970, 90],
      [950, 90],
      [930, 180],
      [750, 200],
      [750, 100],
      [728, 90],
      [728, 250],
      [728, 100]
    ],
    id: 'div-gpt-ad-Top_Side-1140x250'
  },
  TOP_SIDE_980x250: {
    path: '/150277392/FMPedia_IL/Super_LeaderBoard',
    sizes: [
      [980, 120],
      [980, 90],
      [970, 250],
      [970, 120],
      [970, 90],
      [950, 90],
      [930, 180],
      [750, 200],
      [750, 100],
      [728, 90],
      [728, 250],
      [728, 100]
    ],
    id: 'div-gpt-ad-Top_Side-980x250'
  },
  TOP_SIDE_750x250: {
    path: '/150277392/FMPedia_IL/Super_LeaderBoard',
    sizes: [
      [750, 200],
      [750, 100],
      [728, 90],
      [728, 250],
      [728, 100]
    ],
    id: 'div-gpt-ad-Top_Side-750x250'
  },
  TOP_SIDE_320x50: {
    path: '/150277392/FMPedia_IL/Super_LeaderBoard',
    sizes: [
      [320, 50],
      [300, 50]
    ],
    id: 'div-gpt-ad-Top_Side-320x50'
  },
  RIGHT_SIDE_1_250x360: {
    path: '/150277392/FMPedia_IL/Super_RightSky_1',
    sizes: [[250, 360]],
    id: 'div-gpt-ad-Super_Right_1-250x360'
  },
  RIGHT_SIDE_2_250x360: {
    path: '/150277392/FMPedia_IL/Super_RightSky_2',
    sizes: [[250, 360]],
    id: 'div-gpt-ad-Super_Right_2-250x360'
  },
  MPU_1_250x250: {
    path: '/150277392/FMPedia_IL/MPU_1',
    sizes: [250, 250],
    id: 'div-gpt-ad-MPU_1-250x250'
  },
  MPU_2_250x250: {
    path: '/150277392/FMPedia_IL/MPU_2',
    sizes: [250, 250],
    id: 'div-gpt-ad-MPU_2-250x250'
  },
  MPU_3_250x250: {
    path: '/150277392/FMPedia_IL/MPU_3',
    sizes: [250, 250],
    id: 'div-gpt-ad-MPU_3-250x250'
  },
  START_TRADING_240x40: {
    path: '/150277392/FMPedia_IL/Start_Trading',
    sizes: [240, 40],
    id: 'div-gpt-ad-START_TRADING-240x40'
  }
}

export const DFP_BANNER_MOCKED = {
  MOCKED_320X50: {
    path: '',
    sizes: [320, 50],
    id: ''
  },
  MOCKED_728X90: {
    path: '',
    sizes: [728, 90],
    id: ''
  },
  MOCKED_970X90: {
    path: '',
    sizes: [970, 90],
    id: ''
  },
  MOCKED_120x600: {
    path: '',
    sizes: [120, 600],
    id: ''
  },
  MOCKED_160x600: {
    path: '',
    sizes: [160, 600],
    id: ''
  },
  MOCKED_300x600: {
    path: '',
    sizes: [300, 600],
    id: ''
  },
  MOCKED_300x250: {
    path: '',
    sizes: [300, 250],
    id: ''
  },
  MOCKED_180x150: {
    path: '',
    sizes: [180, 150],
    id: ''
  }
}
